var _defs, _path, _g, _polygon, _rect, _g2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHireLogoV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 372.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #03cfc2;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M755.01,264.64V0h244.26v66.98h-177.28v130.32h178.01v67.34h-244.99ZM854.39,155.44v-50.6h134.69v50.6h-134.69Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 302.55,
    width: 12.11,
    height: 69.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.8,352.68l-48.89-48.51c-.89-.89-1.75-1.53-2.58-1.91-.83-.38-1.68-.57-2.57-.57-1.91,0-3.42.65-4.53,1.95-1.11,1.3-1.67,3.07-1.67,5.29v62.91h11.53v-50.71l48.71,48.99c1.71,1.72,3.56,2.57,5.53,2.57,1.78,0,3.22-.64,4.34-1.91,1.11-1.27,1.67-3.05,1.67-5.34v-63.48h-11.53v50.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "142.02 314.66 168.32 314.66 168.32 371.84 180.42 371.84 180.42 314.66 206.73 314.66 206.73 302.55 142.02 302.55 142.02 314.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "245.81 341.72 293.08 341.72 293.08 331.53 245.81 331.53 245.81 314.66 295.66 314.66 295.66 302.55 233.8 302.55 233.8 371.84 295.75 371.84 295.75 359.74 245.81 359.74 245.81 341.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "337.31 302.55 325.2 302.55 325.2 371.84 383.91 371.84 383.91 359.74 337.31 359.74 337.31 302.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "423.75 302.55 411.65 302.55 411.65 371.84 470.36 371.84 470.36 359.74 423.75 359.74 423.75 302.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 498.76,
    y: 302.55,
    width: 12.11,
    height: 69.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M572.63,341.72h31.26v18.01h-29.64c-3.12,0-5.99-.57-8.63-1.72-2.64-1.14-4.91-2.72-6.82-4.72-1.91-2-3.4-4.4-4.48-7.2-1.08-2.8-1.62-5.82-1.62-9.05s.54-6.32,1.62-9.05c1.08-2.73,2.57-5.08,4.48-7.05,1.91-1.97,4.18-3.51,6.82-4.62s5.51-1.67,8.63-1.67h37.55v-12.1h-37.55c-4.83,0-9.29.81-13.39,2.43-4.1,1.62-7.66,3.91-10.67,6.86-3.02,2.95-5.37,6.53-7.05,10.72-1.68,4.19-2.53,8.83-2.53,13.92s.84,9.69,2.53,14.01c1.68,4.32,4.03,8.05,7.05,11.2,3.02,3.14,6.58,5.62,10.67,7.43,4.1,1.81,8.56,2.72,13.39,2.72h41.84v-40.32h-43.46v10.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "658.31 341.72 705.59 341.72 705.59 331.53 658.31 331.53 658.31 314.66 708.16 314.66 708.16 302.55 646.3 302.55 646.3 371.84 708.25 371.84 708.25 359.74 658.31 359.74 658.31 341.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M797.66,352.68l-48.89-48.51c-.89-.89-1.75-1.53-2.58-1.91-.83-.38-1.68-.57-2.57-.57-1.91,0-3.42.65-4.53,1.95-1.11,1.3-1.67,3.07-1.67,5.29v62.91h11.53v-50.71l48.71,48.99c1.71,1.72,3.56,2.57,5.53,2.57,1.78,0,3.22-.64,4.34-1.91,1.11-1.27,1.67-3.05,1.67-5.34v-63.48h-11.53v50.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M858.22,304.98c-4.1,1.62-7.66,3.91-10.67,6.86-3.02,2.95-5.37,6.53-7.05,10.72-1.68,4.19-2.53,8.83-2.53,13.92s.84,9.69,2.53,14.01c1.68,4.32,4.03,8.05,7.05,11.2,3.02,3.14,6.58,5.62,10.67,7.43,4.1,1.81,8.56,2.72,13.39,2.72h37.55v-12.1h-37.55c-3.12,0-5.99-.57-8.63-1.72-2.64-1.14-4.91-2.72-6.82-4.72-1.91-2-3.4-4.4-4.48-7.2-1.08-2.8-1.62-5.82-1.62-9.05s.54-6.32,1.62-9.05c1.08-2.73,2.57-5.08,4.48-7.05,1.91-1.97,4.18-3.51,6.82-4.62s5.51-1.67,8.63-1.67h37.55v-12.1h-37.55c-4.83,0-9.29.81-13.39,2.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "950.06 359.74 950.06 341.72 997.33 341.72 997.33 331.53 950.06 331.53 950.06 314.66 999.91 314.66 999.91 302.55 938.05 302.55 938.05 371.84 1000 371.84 1000 359.74 950.06 359.74"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "200.94 101.93 67.34 101.93 67.34 0 0 0 0 264.64 67.34 264.64 67.34 158.71 268.28 158.71 268.28 0 200.94 0 200.94 101.93"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 309.43,
    width: 67.34,
    height: 115.73
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 200.94,
    y: 180.58,
    width: 67.34,
    height: 84.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 309.43,
    y: 137.6,
    width: 67.34,
    height: 127.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 417.92,
    y: 88.85,
    width: 66.98,
    height: 175.8
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.08,185.29c32.4-13.11,52.79-42.23,52.79-85.55,0-60.79-37.86-99.74-101.56-99.74h-194.39v66.98h194.39c22.21,0,35.68,13.47,35.68,35.31s-13.47,35.31-35.68,35.31h-105.54v56.42h76.05l50.89,70.62h89.61l-62.23-79.36Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireLogoV2);
export default __webpack_public_path__ + "static/media/hire-logo-v2.9b06ac49217911efd530da8b2a2efbba.svg";
export { ForwardRef as ReactComponent };